import { render, staticRenderFns } from "./EditPositionOverlay.vue?vue&type=template&id=2daa8641&scoped=true&"
import script from "./EditPositionOverlay.vue?vue&type=script&lang=ts&"
export * from "./EditPositionOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./EditPositionOverlay.vue?vue&type=style&index=0&id=2daa8641&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daa8641",
  null
  
)

export default component.exports